export default __webpack_public_path__ + "static/media/future_messages.dc028f31.png";